import React from 'react'
import styles from './styles.css'
import Button from 'orionsoft-parts/lib/components/Button'
import {Form, Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import autobind from 'autobind-decorator'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import {changePassword} from 'meteor-apollo-accounts'
import {withApollo} from 'react-apollo'
import PropTypes from 'prop-types'

@withMessage
@withApollo
export default class ChangePassword extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    client: PropTypes.func,
    showMessage: PropTypes.func
  }

  state = {}

  @autobind
  async save({oldPassword, newPassword, confirm}) {
    var myReg= /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,}$/
    if(myReg.test(this.state.newPassword) === false){
      return this.setState({errorMessage: 'Debe de tener mínimo 8 caracteres, una minúscula, una mayúscula y un número'})
    }
    if (newPassword !== confirm) {
      return this.setState({errorMessage: 'No coinciden las contraseñas'})
    }
    this.setState({loading: true, errorMessage: ''})
    try {
      await changePassword({oldPassword, newPassword}, this.props.client)
      this.props.showMessage('Contraseña modificada exitosamente')
      this.setState({errorMessage: ''})
    } catch (error) {
      this.setState({errorMessage: error.message})
      this.form.clearForm()
      
    }
    this.setState({loading: false})
  }

  

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <h3 className={styles.title}>Cambiar contraseña</h3>
          </div>
          <div className="content">
            <Form
              ref={form => {
                this.form = form
              }}
              state={this.state}
              onChange={state => this.setState(state)}
              onSubmit={this.save}
            >
              <Field
                fieldName="oldPassword"
                fieldType="password"
                placeholder="Contraseña actual"
                minLength = '8'
                type={Text}
              />
              <div className={styles.divider} />
              <Field
                fieldName="newPassword"
                fieldType="password"
                placeholder="Nueva contraseña"
                minLength = '8'
                type={Text}
              />
              <Field fieldName="confirm" fieldType="password" placeholder="Confirmar" type={Text} minLength = '8'/>
            </Form>
            <br />
            <div className={styles.error}>{this.state.errorMessage}</div>
            <Button loading={this.state.loading} primary onClick={() => this.form.submit()}>
              Cambiar contraseña
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Password/index.js